var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhatsapp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "currentColor",
  d: "M8 0C3.578 0 0 3.576 0 8c0 1.668.509 3.211 1.413 4.538a.4.4 0 0 1 .05.343L.65 15.6l2.663-.919a.4.4 0 0 1 .343.044A7.95 7.95 0 0 0 8 16c4.424 0 8-3.576 8-8s-3.576-8-8-8M4.725 3.488l1.456 2.406-.606.6a.4.4 0 0 0-.062.481c.925 1.602 2.02 2.849 3.556 3.525a.4.4 0 0 0 .443-.081l.644-.644 2.35 1.469c-.26.585-.6.934-.987 1.137-.45.236-.999.28-1.625.15-1.253-.26-2.767-1.244-4-2.506S3.706 7.229 3.463 5.981c-.122-.624-.068-1.161.162-1.587.198-.367.535-.681 1.1-.907",
  clipRule: "evenodd"
})));
export default SvgWhatsapp;